import { Action } from '@ngrx/store';
import { SortOptionsEnum } from '~shared/modules/application-event/models/sort-option.model';

export enum SortActionTypes {
  SET_SORT = '[BrandPLPPage] Set sorting option',
  SET_SORT_WITHOUT_NAVIGATION = '[BrandPLPPage] Set sorting option without navigation'
}

export class SetSort implements Action {
  readonly type = SortActionTypes.SET_SORT;

  constructor(public payload: SortOptionsEnum) {
  }
}

export class SetSortWithoutNavigation implements Action {
  readonly type = SortActionTypes.SET_SORT_WITHOUT_NAVIGATION;

  constructor(public payload: SortOptionsEnum) {
  }
}

export type SortActionsUnion = SetSort | SetSortWithoutNavigation;
